import { Theme } from '@material-ui/core'

const apartmentStyles = ({ breakpoints, spacing, typography }: Theme) => ({
  button: {
    marginTop: spacing(2)
  },
  responsiveButtonAfterShowing: {
    height: '4.8rem',
    fontSize: '1.5rem',
    textTransform: 'none' as const,
    boxShadow: 'none',
    marginBottom: '8px',
    borderRadius: '15px',
    [breakpoints.down('sm')]: {
      height: '3.8rem',
      h6: {
        fontSize: '1rem'
      }
    }
  },
  responsiveButton: {
    height: '4.8rem',
    fontSize: '1.5rem',
    textTransform: 'none' as const,
    boxShadow: 'none',
    marginBottom: '8px',
    [breakpoints.down('sm')]: {
      height: '3.8rem',
      h6: {
        fontSize: '1rem'
      }
    }
  },
  primaryBtn: {
    backgroundColor: '#94004A',
    '&:hover': {
      backgroundColor: '#670033'
    }
  },
  readMoreButton: {
    backgroundColor: '#fff',
    border: 'none',
    color: '#2F2F2F',
    fontSize: '12px',
    minWidth: 'fit-content',
    padding: '0',
    textTransform: 'none' as const,
    lineHeight: 'normal',
    marginLeft: '15px',
    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: 'none'
    },
    boxShadow: 'none'
  },
  readMoreButtonText: {
    [breakpoints.down('xs')]: {
      display: 'none',
      '& + span': {
        fontSize: '20px'
      }
    }
  },
  logoutButton: {
    marginTop: '1rem'
  },
  autocomplete: {
    marginTop: spacing(2)
  },
  imageContainer: {
    width: '100%',
    height: '50%',
    alignItems: 'flex-start',
    [breakpoints.down('sm')]: {
      display: 'none'
    },
    [breakpoints.up('md')]: {
      display: 'inline-flex'
    },
    [breakpoints.up('lg')]: {}
  },
  image: {
    width: '100%'
  },
  formPaper: {
    display: 'flex',
    boxShadow: 'none',
    flexDirection: 'column' as const,
    minWidth: '85%'
    // padding: '25px 30px 25px 30px',
    // [breakpoints.down('md')]: {
    //   padding: '35px 25px 45px 25px'
    // },
    // [breakpoints.down('sm')]: {
    //   padding: '15px 20px 15px 20px'
    // }
  },
  form: {
    display: 'flex',
    maxHeigth: '1200px',
    [breakpoints.down('sm')]: {
      width: '95vw'
    },
    '@media (min-width: 2000px)': {
      display: 'flex',
      maxWidth: '1000px'
    }
  },
  contentContainer: {
    width: 'fit-content'
  },
  containerItem: {
    marginTop: '20px'
  },
  buttonContainer: {
    marginTop: '10px',
    maxWidth: '550px'
  },
  largeForm: {
    padding: '35px 0 15px 0',
    maxWidth: '550px',
    display: 'flex',
    [breakpoints.down('sm')]: {
      padding: '10px 0'
    },
    [breakpoints.up('lg')]: {
      display: 'flex',
      maxWidth: '550px'
    }
  },
  stepper: {
    backgroundColor: 'inherit',
    [breakpoints.down('sm')]: {
      padding: '11px'
    }
  },
  stepLabel: {
    [breakpoints.down('sm')]: {
      fontSize: '0.7rem'
    },
    [breakpoints.down('xs')]: {
      fontSize: '0.65rem'
    }
  },
  firstStepHeading: {
    [breakpoints.down('xs')]: {
      fontSize: '21.5px'
    }
  },
  datePicker: {
    position: 'relative' as const,
    width: '100%',
    textAlign: 'left' as const,
    '& > label': {
      fontFamily: 'CircularRegular',
      display: 'inline-block',
      paddingBottom: '0.5rem'
    },
    '& .MuiInput-underline': {
      margin: '0',
      '&::after': {
        content: 'none !important'
      },
      '&::before': {
        content: 'none !important'
      }
    },
    '& > svg': {
      display: 'inline-block',
      height: '1rem',
      width: '1rem',
      content: '""',
      background: 'transparent',
      color: 'gray',
      position: 'absolute' as const,
      top: '35%',
      left: '10px',
      zIndex: '15',
      cursor: 'pointer',
      pointerEvents: 'none'
    },
    '& .MuiTextField-root': {
      '& label': {
        zIndex: '15',
        display: 'none',
        position: 'absolute',
        margin: '0'
      },
      '& input': {
        background: '#E7ECEF',
        fontSize: '16px',
        cursor: 'pointer',
        zIndex: '10',
        padding: '10px 7px 10px 21px',
        borderRadius: '6px',
        minHeight: '35px',
        border: 'none',
        '&::after': {
          content: 'none !important'
        }
      }
    },
    '& .Mui-error': {
      fontSize: '11px',
      margin: '0',
      marginTop: '3px',
      textAlign: 'left',
      fontFamily: 'CircularRegular',
      'font-weight': '400',
      lineHeight: '1.66',
      letterSpacing: '0.03333em'
    }
  },
  centeredText: {
    textAlign: 'center' as const
  },
  largeText: {
    fontSize: '2rem',
    [breakpoints.down('sm')]: {
      fontSize: '1.75rem'
    }
  },
  boldText: {
    fontWeight: 'bold' as const
  },
  inlineText: {
    display: 'inline'
  },
  mediumRadius: {
    borderRadius: '20px'
  },
  greyBackground: {
    background: '#E7ECEF'
  },
  moversField: {
    width: '300px',
    borderRadius: '8px',
    [breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  authPop: {
    padding: '64px 80px',
    [breakpoints.down('sm')]: {
      padding: '24px'
    }
  },
  whiteBg: {
    background: '#fff'
  },
  marginAuto: {
    margin: 'auto'
  },
  addNewTenantStyles: {
    padding: '64px 48px',
    [breakpoints.down('sm')]: {
      padding: '20px'
    }
  },
  addNewTenantDetailsStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#FBF6EE',
    borderRadius: 20,
    fontSize: 18,
    lineHeight: 20,
    fontWeight: 100,
    paddingRight: 60,
    paddingLeft: 60,
    paddingTop: 20,
    paddingBottom: 20,
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      paddingRight: '0px',
      paddingLeft: '0px'
    }
  },
  modalPrimaryButton: {
    width: '80%',
    backgroundColor: '#94004A',
    color: '#fff',
    borderRadius: '10px',
    height: '65px',
    fontWeight: 'bold' as const,
    textTransform: 'none' as const,
    fontSize: '1.375rem',
    marginbottom: '1rem',
    '&:hover': {
      backgroundColor: '#94004A'
    }
  },
  modalSecondaryButton: {
    width: '80%',
    backgroundColor: '#fff',
    color: '#D43838',
    borderRadius: '10px',
    height: '65px',
    fontWeight: 'bold' as const,
    textTransform: 'none' as const,
    fontSize: '1.375rem',
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  mb6: {
    marginBottom: '1.5rem'
  },
  mb12: {
    marginBottom: '3rem'
  },
  mb14: {
    marginBottom: '3.5rem'
  },
  checkboxField: {
    '& input': {
      backgroundColor: 'red'
    }
  },
  fullWidth: {
    width: '100%'
  },
  shadowSecondaryButton: {
    boxShadow: '0px 0px 10px rgb(0 0 0 / 20%)',
    borderRadius: '10px'
  },
  leftFloatingIcon: {
    position: 'absolute' as const,
    left: '0.5rem',
    top: '1.3rem',
    [breakpoints.down('sm')]: {
      top: '1rem'
    }
  },
  rightFloatingIcon: {
    position: 'absolute' as const,
    right: '0.5rem',
    top: '1.3rem',
    [breakpoints.down('sm')]: {
      top: '1rem'
    }
  },
  my4: {
    marginTop: '1rem',
    marginBottom: '1rem'
  },
  my6: {
    marginTop: '1.5rem',
    marginBottom: '1.5rem'
  },
  my8: {
    marginTop: '2rem',
    marginBottom: '2rem'
  },
  my9: {
    marginTop: '2.25rem',
    marginBottom: '2.25rem'
  },
  downloadPrompt: {
    padding: '2rem 0'
  },
  privacyStatementLink: {
    textDecoration: 'none',
    color: '#E2EBFD',
    fontSize: '1.125rem',
    fontFamily: 'CircularBold'
  },
  underlinedLink: {
    fontSize: '1.25rem',
    fontFamily: 'CircularRegular',
    color: '#000'
  },
  mdText: {
    fontSize: typography.pxToRem(18)
  }
})

export { apartmentStyles }
